import { jsxs as A, Fragment as J, jsx as u } from "react/jsx-runtime";
import { useState as w, useEffect as I, useRef as ce, useMemo as z, useCallback as _ } from "react";
import { D as oe, a as j, u as pe, S as ee, L as X, g as ue, c as de, b as fe, f as he, d as ye, P as me, N as be } from "./location-query-DoEWhnej.js";
import { D as G, b as Se, A as Te, a as W, g as Y, s as $, M as ge } from "./MapView-C6gXpjuJ.js";
import { S as Ce } from "./SortBy-Byf0WmXy.js";
import { u as ve, B as Z } from "./useMediaQuery-BZAMobKw.js";
import { S as _e } from "./Section-DOeCOW54.js";
import { F as P } from "./FlexContainer-CoykMrGV.js";
import { G as we } from "./Gap-BresIL53.js";
import { g as ae } from "./link-utils-yTXHuXGc.js";
import { C as Le } from "./CardGrid-JhNXXSJv.js";
import { S as Ae } from "./ApartmentCard-BfyZfamk.js";
const m = {
  spaceFeatures: "spaceFeatures",
  spaceType: "spaceType",
  spaceSize: "spaceSize",
  spaceAvailability: "spaceAvailability",
  spaceCapacity: "spaceCapacity",
  addressType: "addressType"
}, v = {
  spaceType: "Corporate",
  spaceAvailability: "Calender",
  spaceFeatures: "Tree",
  spaceSize: "Square",
  spaceCapacity: "Person",
  addressType: "Location"
}, Fe = [
  { label: "1-10", checked: !1 },
  { label: "11-30", checked: !1 },
  { label: "31-50", checked: !1 },
  { label: "Yli 51", checked: !1 }
], ke = [
  { label: "Alle 200 m²", checked: !1 },
  { label: "201-400 m²", checked: !1 },
  { label: "401-700 m²", checked: !1 },
  { label: "Yli 701 m²", checked: !1 }
], te = (t, e) => !e || t.length === 0 ? !1 : t.some(
  (a) => e.toLowerCase().includes(a.value.toLowerCase())
), Be = (t, e) => te(t, e), Oe = (t, e) => te(t, e), Ve = (t, e) => Array.isArray(e) && t.some(
  (a) => e.some(
    (r) => r.toLowerCase().includes(a.value.toLowerCase())
  )
), Pe = (t, e) => t.some((a) => a.type !== m.spaceSize || e === void 0 ? !1 : a.value.includes("200") ? e >= 1 && e <= 200 : a.value.includes("201-400") ? e >= 201 && e <= 400 : a.value.includes("401-700") ? e >= 401 && e <= 700 : a.value.includes("701") ? e >= 770 : !1) || !1, Ie = (t, e) => t.some((a) => a.type !== m.spaceCapacity || e === void 0 ? !1 : a.value.includes("1-10") ? e >= 1 && e <= 230 : a.value.includes("11-30") ? e >= 170 && e <= 630 : a.value.includes("31-50") ? e >= 470 && e <= 1130 : a.value.includes("51") ? e >= 770 : !1), Me = (t) => t.flatMap((e) => {
  const a = e.value.toLowerCase();
  if (a.includes("varasto- tai tuotantotila"))
    return [
      { ...e, value: "Varastotila" },
      { ...e, value: "Tuotantotila" }
    ];
  if (a.includes("m²")) {
    const r = a.replace("m²", "").trim();
    let s = 0, l = 1 / 0;
    return r.startsWith("alle") ? l = Number(r.replace("alle", "").trim()) : r.startsWith("yli") ? s = Number(r.replace("yli", "").trim()) : r.includes("-") && ([s, l] = r.split("-").map((n) => Number(n.trim()) || 0)), [{ ...e, min: s, max: l }];
  }
  if (a.includes("-") || a.startsWith("yli")) {
    let [r, s] = a.split("-").map((l) => Number(l.trim()));
    return a.toLowerCase().startsWith("yli") && (r = Number(a.toLowerCase().replace("yli", "").trim()), s = 1 / 0), [{ ...e, min: r, max: s }];
  }
  return e;
}), Ne = (t, e) => {
  if (e.length === 0)
    return t;
  const a = Me(e);
  return t.filter((r) => {
    const { type: s, status: l, features: n, surfaceArea: o } = r;
    return a.length === 0 ? !0 : a.every((i) => i.type === m.spaceType ? Be(a, s ?? "") : i.type === m.spaceAvailability ? Oe(a, l ?? "") : i.type === m.spaceFeatures ? Ve(a, n ?? []) : i.type === m.spaceSize ? Pe(a, Number(o)) : i.type === m.spaceCapacity ? Ie(a, Number(o)) : !0);
  });
}, re = (t) => t.type ? `${t.type.charAt(0).toUpperCase() + t.type.slice(1)}, ${t.apartmentPropertyName}` : `Unknown, ${t.apartmentPropertyName}`, se = (t) => [
  `${t.floor} krs`,
  t.propertyAddress,
  t.apartmentPropertyCity
].filter(Boolean).join(", ") || "Ei osoitetta saatavilla", Re = (t) => t.map((e) => {
  var l;
  const a = re(e), r = se(e);
  return {
    type: "office",
    data: {
      url: ae(e.id),
      title: a,
      subtitle: r,
      squareFeet: ((l = e.surfaceArea) == null ? void 0 : l.toString()) ?? "0",
      image: e.images,
      size: "large",
      tagText: e.status
    }
  };
}), ze = (t) => t.map((e) => {
  var l;
  const a = re(e), r = se(e);
  return {
    url: ae(e.id),
    title: a,
    subtitle: r,
    squareFeet: ((l = e.surfaceArea) == null ? void 0 : l.toString()) ?? "0",
    image: e.images,
    size: "large",
    tagText: e.status,
    lat: e.lat,
    lng: e.lng,
    apartmentPropertyUrl: e.propertyUrl,
    apartmentPropertyImageUrl: e.propertyImageUrl,
    apartmentPropertySubtitle: e.propertySubtitle,
    apartmentPropertyTitle: e.propertyTitle
  };
}), xe = (t) => t.reduce((e, a) => {
  const {
    lat: r,
    lng: s,
    apartmentPropertyName: l,
    apartmentPropertyCity: n,
    propertyAddress: o,
    propertyPostalCode: i,
    propertyDistrict: p,
    features: d,
    officeSpaces: y,
    propertyDetails: g,
    apartmentPropertyImageUrl: C,
    apartmentPropertyUrl: h
  } = a, b = y && y.map((S) => ({
    ...S,
    lat: r,
    lng: s,
    apartmentPropertyName: l,
    apartmentPropertyCity: n,
    propertyAddress: o,
    propertyPostalCode: i,
    propertyDistrict: p,
    features: d,
    address: g == null ? void 0 : g.address,
    technicalType: g == null ? void 0 : g.technicalType,
    propertyUrl: h,
    propertyImageUrl: C,
    propertyTitle: l,
    propertySubtitle: p + ", " + n,
    images: S.images && S.images.length > 0 ? S.images[0] : ""
  }));
  return e.concat(b || []);
}, []), De = (t, e, a) => {
  const r = /* @__PURE__ */ new Map();
  t.forEach((l) => {
    var n;
    (n = l.features) == null || n.forEach((o) => {
      if (!r.has(o)) {
        const i = {
          label: o,
          checked: !1,
          icon: v.spaceFeatures
        };
        r.set(o, {
          ...i,
          onClick: () => e(i)
        });
      }
    });
  });
  const s = ["Keskustan palvelut", "Lähialueen palvelut"];
  for (const [l] of r)
    s.includes(l) && r.delete(l);
  a(Array.from(r.values()));
}, Ee = (t, e, a) => {
  const r = /* @__PURE__ */ new Map();
  t.forEach((n) => {
    var o;
    (o = n.officeSpaces) == null || o.forEach((i) => {
      const p = i.type;
      if (p && !r.has(p)) {
        let d = "Trolley";
        p.toLowerCase().includes("liike") && (d = "Mall"), p.toLowerCase().includes("toimisto") && (d = "DoorOpen"), r.set(p, {
          label: p,
          icon: d,
          checked: !1,
          onClick: () => e({
            label: p,
            icon: d
          })
        });
      }
    });
  });
  const l = Array.from(r.values()).filter(
    (n, o, i) => o === i.findIndex(
      (p) => p.label.trim().toLowerCase() === n.label.trim().toLowerCase()
    )
  );
  a(l);
}, Ue = (t, e, a) => {
  const r = /* @__PURE__ */ new Map();
  t.forEach((n) => {
    var o;
    (o = n.officeSpaces) == null || o.forEach((i) => {
      const p = i.status;
      p && !r.has(p) && r.set(p, {
        label: p,
        icon: "Corporate",
        checked: !1,
        onClick: () => e({
          label: p,
          icon: "Corporate",
          checked: !1
        })
      });
    });
  });
  const l = Array.from(r.values()).filter(
    (n, o, i) => o === i.findIndex(
      (p) => p.label.trim().toLowerCase() === n.label.trim().toLowerCase()
    )
  );
  a(l);
}, q = ({
  spaceType: t,
  spaceAvailability: e,
  spaceCapacity: a,
  spaceSize: r,
  spaceFeatures: s,
  filterLabels: l,
  modal: n = !1,
  selectedTags: o
}) => /* @__PURE__ */ A(J, { children: [
  t && /* @__PURE__ */ u(
    G,
    {
      filterIcon: v.spaceType,
      filterLabel: l.spaceType,
      filterSelected: n && !!o.find((i) => i.type === "spaceType"),
      disabled: t.length === 0,
      children: /* @__PURE__ */ u(oe, { items: t })
    }
  ),
  e && /* @__PURE__ */ u(
    G,
    {
      filterIcon: v.spaceAvailability,
      filterLabel: l.spaceAvailability,
      filterSelected: n && !!o.find((i) => i.type === "spaceAvailability"),
      disabled: e.length === 0,
      children: /* @__PURE__ */ u(j, { items: e })
    }
  ),
  a && /* @__PURE__ */ u(
    G,
    {
      filterIcon: v.spaceCapacity,
      filterLabel: l.spaceCapacity,
      filterSelected: n && !!o.find((i) => i.type === "spaceCapacity"),
      disabled: a.length === 0,
      children: /* @__PURE__ */ u(j, { items: a })
    }
  ),
  r && /* @__PURE__ */ u(
    G,
    {
      filterIcon: v.spaceSize,
      filterLabel: l.spaceSize,
      filterSelected: n && !!o.find((i) => i.type === "spaceSize"),
      disabled: r.length === 0,
      children: /* @__PURE__ */ u(j, { items: r })
    }
  ),
  s && /* @__PURE__ */ u(
    G,
    {
      filterIcon: v.spaceFeatures,
      filterLabel: l.spaceFeatures,
      filterSelected: n && !!o.find((i) => i.type === "spaceFeatures"),
      isLastItem: !0,
      disabled: s.length === 0,
      children: /* @__PURE__ */ u(j, { items: s })
    }
  )
] }), Ge = "elo-mobile", Ye = "elo-desktop", L = {
  "search-filter": "elo-search-filter",
  "search-filter__container": "elo-search-filter__container",
  mobile: Ge,
  "search-filter__container__chips": "elo-search-filter__container__chips",
  "search-filter__container__buttons": "elo-search-filter__container__buttons",
  "search-filter__container__button": "elo-search-filter__container__button",
  "search-filter__tags": "elo-search-filter__tags",
  "search-filter__sort-by": "elo-search-filter__sort-by",
  "search-filter__mobile-tags": "elo-search-filter__mobile-tags",
  "sticky-container": "elo-sticky-container",
  desktop: Ye
}, je = ({
  cities: t,
  spaceType: e,
  spaceAvailability: a,
  spaceCapacity: r,
  spaceSize: s,
  spaceFeatures: l,
  handleOptionClick: n,
  onSearchPress: o,
  selectedTags: i,
  onRemoveTag: p,
  onRemoveAllTags: d,
  onClickMapView: y,
  autoCompleteInputPlaceholder: g,
  autocompleteDropdownTitle: C,
  onHandleInputChange: h,
  modalOpenerButtonText: b,
  modalHeadingText: S,
  clearFiltersButtonText: T,
  displayResultsButtonText: k,
  isDisplayingMapView: F,
  openMapViewButtonText: B,
  openCardViewButtonText: x,
  removeAllTagsText: D,
  googleMapApiKey: E,
  filterLabels: M,
  disableMapView: c = !1,
  sortByLabel: f,
  sortOptions: N,
  onHandleSortByChange: R
}) => {
  const { isOpen: O, handleOpeningModal: le, handleClosingModal: ie } = pe(), Q = ve("(max-width: 490px)"), V = i.find(
    (U) => U.type === m.addressType
  );
  return /* @__PURE__ */ A(_e, { className: L["sticky-container"], children: [
    /* @__PURE__ */ u(
      Se,
      {
        heading: S,
        isOpen: O,
        onClose: ie,
        onClearFilters: d,
        tagIsSelected: i.length === 0,
        clearFiltersButtonText: T,
        displayResultsButtonText: k,
        children: /* @__PURE__ */ u(
          q,
          {
            spaceType: e,
            spaceAvailability: a,
            spaceCapacity: r,
            spaceSize: s,
            spaceFeatures: l,
            filterLabels: M,
            modal: !0,
            selectedTags: i
          }
        )
      }
    ),
    /* @__PURE__ */ A(P, { direction: "column", className: L["search-filter"], children: [
      /* @__PURE__ */ A(P, { className: L["search-filter__container"], children: [
        /* @__PURE__ */ u(
          Te,
          {
            placeholder: g,
            cities: t,
            onOptionClick: n,
            onSearchPress: o,
            options: t,
            dropDownLabel: C,
            onHandleInputChange: h,
            googleMapApiKey: E
          },
          V == null ? void 0 : V.value
        ),
        Q && V && /* @__PURE__ */ u(P, { className: L["search-filter__mobile-tags"], children: /* @__PURE__ */ u(
          W,
          {
            icon: V.icon,
            tag: V.value,
            onRemoveTag: () => p(V)
          }
        ) }),
        /* @__PURE__ */ u(
          P,
          {
            direction: "row",
            className: L["search-filter__container__chips"],
            children: /* @__PURE__ */ u(
              q,
              {
                spaceType: e,
                spaceAvailability: a,
                spaceCapacity: r,
                spaceSize: s,
                spaceFeatures: l,
                filterLabels: M,
                selectedTags: i
              }
            )
          }
        ),
        /* @__PURE__ */ A("div", { className: L["search-filter__container__buttons"], children: [
          /* @__PURE__ */ u(
            Z,
            {
              iconLeft: "Tune",
              className: L["search-filter__container__button"],
              onClick: le,
              small: !1,
              children: b
            }
          ),
          Q && /* @__PURE__ */ u(
            Z,
            {
              variant: "secondary",
              iconLeft: "Map",
              onClick: y,
              disabled: c,
              small: !1,
              children: F ? x : B
            }
          )
        ] })
      ] }),
      !Q && /* @__PURE__ */ A(P, { justifyContent: "space-between", children: [
        /* @__PURE__ */ A(
          P,
          {
            className: L["search-filter__tags"],
            justifyContent: "center",
            children: [
              i.map((U, ne) => /* @__PURE__ */ u(
                W,
                {
                  icon: U.icon,
                  tag: U.value,
                  onRemoveTag: () => p(U)
                },
                ne
              )),
              i.length > 1 && /* @__PURE__ */ u(
                W,
                {
                  lastTagText: D,
                  onRemoveAllTags: d
                },
                "remove-all"
              )
            ]
          }
        ),
        !F && /* @__PURE__ */ u("div", { className: L["search-filter__sort-by"], children: /* @__PURE__ */ u(
          Ce,
          {
            options: N,
            onChange: R,
            label: f,
            sortByOptionsSessionStorageKey: ee,
            defaultOptionValue: "default"
          }
        ) })
      ] })
    ] })
  ] });
};
function He({
  lang: t,
  requestVerificationToken: e,
  disableLocationFetch: a
}) {
  const [r, s] = w([]), [l, n] = w(!0);
  return I(() => {
    const o = async () => {
      if (n(!0), a) {
        const { dummyLocations: p } = await import("./data-D-sPgacL.js");
        s(p.result.pages), n(!1);
      } else
        try {
          const p = await ue(
            "/api/PropertySearchApi/Get/",
            t,
            e
          );
          s(p.result.pages), $(X, p.result.pages);
        } catch (p) {
          console.error("Error fetching locations:", p);
        } finally {
          n(!1);
        }
    }, i = Y(X);
    i ? (s(i), n(!1)) : o();
  }, [a, t, e]), { loading: l, locations: r };
}
const Ke = 20;
function $e(t, e) {
  const { currentLocationCoordinates: a, selectedTags: r, sortOptionValue: s } = e, l = ce(/* @__PURE__ */ new Map()), n = z(
    () => xe(t),
    [t]
  ), o = z(() => (l.current = /* @__PURE__ */ new Map(), a ? n.filter((d) => {
    const y = de(
      d,
      a
    );
    return y <= Ke ? (l.current.set(d.id, y), !0) : !1;
  }) : n), [a, n]), i = z(
    () => Ne(o, r),
    [o, r]
  );
  return z(() => {
    switch (s) {
      case "biggest":
        return i.sort((d, y) => y.surfaceArea - d.surfaceArea);
      case "smallest":
        return i.sort((d, y) => d.surfaceArea - y.surfaceArea);
      case "newest":
        return i.sort(
          (d, y) => new Date(y.created).getTime() - new Date(d.created).getTime()
        );
      default:
        return a ? Qe(i, l.current) : We(i);
    }
  }, [a, i, s]);
}
function Qe(t, e) {
  return t.sort((a, r) => {
    const s = e.get(a.id), l = e.get(r.id);
    return s === void 0 || l === void 0 ? 0 : s - l;
  });
}
function We(t) {
  const e = [], a = Je(
    t.sort((r, s) => s.surfaceArea - r.surfaceArea),
    "address"
  );
  for (; a.size; )
    a.forEach((r, s) => {
      const l = r.shift();
      r.length > 0 ? a.set(s, r) : a.delete(s), l && e.push(l);
    });
  return e;
}
function Je(t, e) {
  return t.reduce((a, r) => {
    const s = String(r[e]), l = a.get(s) || [];
    return a.set(s, [...l, r]), a;
  }, /* @__PURE__ */ new Map());
}
const H = "elo-offices-search-options";
function Xe({
  removeTagsByType: t,
  googleMapApiKey: e,
  selectedTagsOptions: a,
  sortOptions: r
}) {
  const { addUniqueTagOfType: s, toggleTag: l, selectedTags: n } = a, [o, i] = w(null), [p, d] = w(
    () => r.find((h) => h.value === "default") ?? null
  ), y = _(() => {
    i(null), t(m.addressType);
  }, [t]);
  I(() => {
    const h = Y(ee);
    if (h) {
      d(h);
      return;
    }
  }, []);
  const g = _(
    async (h) => {
      const b = fe(h);
      if (b)
        try {
          const S = await he(
            b,
            e
          );
          if (S) {
            i(S);
            const T = {
              ...S,
              type: m.addressType,
              value: h,
              icon: v.addressType
            };
            s(T);
          }
        } catch (S) {
          console.error("Error fetching coordinates:", S), i(null), t(m.addressType);
        }
    },
    [s, e, t]
  );
  I(() => {
    const h = Y("searchOptions");
    h && h.selectedTags && h.selectedTags.forEach((b) => {
      l(b);
    }), h != null && h.coordinates && i(h.coordinates);
  }, [l]), I(() => {
    n && $(H, {
      ...Y(H) || {},
      selectedTags: n
    });
  }, [n]), I(() => {
    o && $(H, {
      ...Y(H) || {},
      coordinates: o
    });
  }, [o]);
  const C = _((h) => {
    d(h);
  }, []);
  return {
    currentLocationCoordinates: o,
    handleOptionClick: g,
    clearSearch: y,
    handleSortChange: C,
    handleSearchQuery: g,
    sortOption: p
  };
}
const K = (t, e) => t.map(
  (a) => a.label === e ? { ...a, checked: !a.checked } : a
), Ze = (t, e) => t.map(
  (a) => a.label === e ? { ...a, selected: !a.selected } : a
), qe = (t, e, a) => {
  const { toggleTag: r, removeTag: s, removeAllTags: l } = e, n = Fe.map((c) => ({
    ...c,
    onClick: () => D(c),
    checked: !1
  })), o = ke.map((c) => ({
    ...c,
    onClick: () => x(c)
  })), [i, p] = w(n), [d, y] = w(o), [g, C] = w([]), [h, b] = w([]), [S, T] = w([]), k = _(
    (c) => {
      T(
        (f) => K(f, c.label)
      ), r({
        type: m.spaceFeatures,
        value: c.label,
        icon: v.spaceFeatures
      });
    },
    [r]
  ), F = _(
    (c) => {
      C(
        (f) => Ze(f, c.label)
      ), r({
        type: m.spaceType,
        value: c.label,
        icon: v.spaceType
      });
    },
    [r]
  ), B = _(
    (c) => {
      b(
        (f) => K(f, c.label)
      ), r({
        type: m.spaceAvailability,
        value: c.label,
        icon: v.spaceAvailability
      });
    },
    [r]
  ), x = _(
    (c) => {
      y(
        (f) => K(f, c.label)
      ), r({
        type: m.spaceSize,
        value: c.label,
        icon: v.spaceSize
      });
    },
    [r]
  ), D = _(
    (c) => {
      p(
        (f) => K(f, c.label)
      ), r({
        type: m.spaceCapacity,
        value: c.label,
        icon: v.spaceCapacity
      });
    },
    [r]
  ), E = _(
    (c) => {
      if (!c) return;
      if (s(c), c.type === m.addressType)
        return a();
      const N = {
        [m.spaceType]: C,
        [m.spaceAvailability]: b,
        [m.spaceCapacity]: p,
        [m.spaceSize]: y,
        [m.spaceFeatures]: T
      }[c.type];
      N && N(
        (R) => R.map(
          (O) => O.label === c.value ? { ...O, checked: !1, selected: !1 } : O
        )
      );
    },
    [s, a]
  ), M = _(() => {
    l(), $("searchOptions", {}), C(
      (c) => c.map((f) => ({ ...f, selected: !1 }))
    ), b(
      (c) => c.map((f) => ({ ...f, checked: !1 }))
    ), p(
      (c) => c.map((f) => ({ ...f, checked: !1 }))
    ), y(
      (c) => c.map((f) => ({ ...f, checked: !1 }))
    ), T(
      (c) => c.map((f) => ({ ...f, checked: !1 }))
    ), a();
  }, [a, l]);
  return I(() => {
    De(t, k, T), Ee(t, F, C), Ue(
      t,
      B,
      b
    );
  }, [
    B,
    k,
    F,
    t
  ]), {
    spaceType: g,
    spaceAvailability: h,
    spaceCapacity: i,
    spaceSize: d,
    spaceFeatures: S,
    setSpaceFeatures: T,
    setSpaceType: C,
    setSpaceAvailability: b,
    handleSpaceAvailability: B,
    handleSpaceFeatures: k,
    handleSpaceType: F,
    handleRemoveTag: E,
    handleRemoveAllTags: M
  };
}, ea = "elo-tablet", aa = "elo-mobile", ta = {
  "search-template": "elo-search-template",
  tablet: ea,
  mobile: aa,
  "search-template__sort-by": "elo-search-template__sort-by"
}, ra = ({
  lang: t,
  requestVerificationToken: e,
  cities: a,
  googleMapApiKey: r,
  texts: s,
  sortOptions: l,
  disableLocationFetch: n
}) => {
  const o = ye("searchOptions"), { selectedTags: i, removeTagsByType: p } = o, { loading: d, locations: y } = He({
    lang: t,
    requestVerificationToken: e,
    disableLocationFetch: n
  }), {
    currentLocationCoordinates: g,
    handleOptionClick: C,
    clearSearch: h,
    handleSortChange: b,
    handleSearchQuery: S,
    sortOption: T
  } = Xe({
    googleMapApiKey: r,
    removeTagsByType: p,
    selectedTagsOptions: o,
    sortOptions: l
  }), {
    spaceType: k,
    spaceAvailability: F,
    spaceCapacity: B,
    spaceSize: x,
    spaceFeatures: D,
    handleRemoveTag: E,
    handleRemoveAllTags: M
  } = qe(y, o, h), c = $e(y, {
    currentLocationCoordinates: g,
    selectedTags: i,
    sortOptionValue: T == null ? void 0 : T.value
  }), [f, N] = w(!1), R = _(() => {
    N((O) => !O);
  }, []);
  return I(() => {
    window.scrollY !== 0 && window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [c]), /* @__PURE__ */ A(P, { direction: "column", className: ta["search-template"], children: [
    /* @__PURE__ */ u(
      me,
      {
        pageTitle: s.pageTitle,
        onClickMapView: R,
        isDisplayingMapView: f,
        openMapViewButtonText: s.openMapViewButtonText,
        openCardViewButtonText: s.openCardViewButtonText,
        disableMapView: c.length === 0
      }
    ),
    /* @__PURE__ */ u(
      je,
      {
        cities: a,
        spaceType: k,
        spaceAvailability: F,
        spaceCapacity: B,
        spaceFeatures: D,
        spaceSize: x,
        onRemoveTag: E,
        onRemoveAllTags: M,
        selectedTags: i || [],
        clearFiltersButtonText: s.clearFiltersButtonText,
        displayResultsButtonText: s.displayResultsButtonText,
        removeAllTagsText: s.removeAllTagsText,
        modalOpenerButtonText: s.modalOpenerButtonText,
        autoCompleteInputPlaceholder: s.autoCompleteInputPlaceholder,
        autocompleteDropdownTitle: s.autocompleteDropdownTitle,
        handleOptionClick: C,
        onSearchPress: S,
        isDisplayingMapView: f,
        openMapViewButtonText: s.openMapViewButtonText,
        openCardViewButtonText: s.openCardViewButtonText,
        onClickMapView: R,
        googleMapApiKey: r,
        filterLabels: {
          spaceType: s.spaceTypeFilterLabel,
          spaceAvailability: s.spaceAvailabilityFilterLabel,
          spaceCapacity: s.spaceCapacityFilterLabel,
          spaceSize: s.spaceSizeFilterLabel,
          spaceFeatures: s.spaceFeaturesFilterLabel
        },
        disableMapView: c.length === 0,
        sortByLabel: s.sortByLabel,
        sortOptions: l,
        onHandleSortByChange: b,
        modalHeadingText: s.modalHeadingText
      }
    ),
    d ? /* @__PURE__ */ u(Ae, {}) : c.length === 0 ? /* @__PURE__ */ A(J, { children: [
      /* @__PURE__ */ u(
        be,
        {
          noResultHeadingText: s.noResultHeadingText,
          noResultParagraphText: s.noResultParagraphText
        }
      ),
      /* @__PURE__ */ u(we, {})
    ] }) : /* @__PURE__ */ u(J, { children: f ? /* @__PURE__ */ u(
      la,
      {
        googleMapApiKey: r,
        mapViewText: s.mapViewText,
        locations: c
      }
    ) : /* @__PURE__ */ u(
      sa,
      {
        locations: c
      },
      T == null ? void 0 : T.value
    ) })
  ] });
};
function sa({ locations: t }) {
  const e = z(
    () => Re(t),
    [t]
  );
  return /* @__PURE__ */ u(Le, { cardData: e });
}
function la({
  googleMapApiKey: t,
  locations: e,
  mapViewText: a
}) {
  const r = z(
    () => ze(e),
    [e]
  );
  return /* @__PURE__ */ u(
    ge,
    {
      googleMapsApiKey: t,
      cardText: a,
      cardData: r,
      cardType: "office"
    }
  );
}
const Sa = ({
  lang: t,
  buttonTexts: e,
  autoComplete: a,
  requestVerificationToken: r,
  cities: s,
  pageTitle: l,
  noResultTexts: n,
  googleMapApiKey: o,
  sortOptions: i,
  modalHeadingText: p,
  mapViewText: d
}) => /* @__PURE__ */ u(
  ra,
  {
    lang: t,
    cities: s,
    requestVerificationToken: r,
    googleMapApiKey: o,
    sortOptions: i,
    texts: {
      modalHeadingText: p,
      clearFiltersButtonText: e.clearFilters,
      displayResultsButtonText: e.displayResults,
      removeAllTagsText: e.removeAllTags,
      modalOpenerButtonText: e.modalOpener,
      autoCompleteInputPlaceholder: a.inputPlaceholder,
      autocompleteDropdownTitle: a.dropdownTitle,
      pageTitle: l,
      openMapViewButtonText: e.openMapView,
      openCardViewButtonText: e.openCardView,
      noResultHeadingText: n.heading,
      noResultParagraphText: n.paragraph,
      spaceTypeFilterLabel: e.spaceTypeFilterLabel,
      spaceAvailabilityFilterLabel: e.spaceAvailabilityFilterLabel,
      spaceCapacityFilterLabel: e.spaceCapacityFilterLabel,
      spaceSizeFilterLabel: e.spaceSizeFilterLabel,
      spaceFeaturesFilterLabel: e.spaceFeaturesFilterLabel,
      sortByLabel: e.sortByLabel,
      mapViewText: d
    }
  }
);
export {
  Sa as SearchPage
};
